<!--
###############################################################################################
######    Vista SVC99000  :  Formulario Pago TPV (Redsys) - Registro del OK     (3/3)    ######
###############################################################################################
-->

<template>
<div>
    <div>
          <!-- <img :src="f99ImageName('ih1-ok-azul')"             height="96"> -->
          <br/>

          <div class="igs-h4" style="color:#009900">Operación APROBADA</div>

          <br/>

          <div class="row">
            <div class="col-md-1">&nbsp;</div>
            <div class="col-md-5 igs-h3 igs-color2">Número de Pedido</div>
            <div class="col-md-5 igs-h3 igs-color1">{{ltReferenciaPedido}}</div>
            <div class="col-md-1">&nbsp;</div>
          </div> 

          <div class="row">
            <div class="col-md-1">&nbsp;</div>
            <div class="col-md-5 igs-h3 igs-color2">Código de Autorización</div>
            <div class="col-md-5 igs-h3 igs-color1">{{ltCodigoAutorizacion}}</div>
            <div class="col-md-1">&nbsp;</div>
          </div> 

          <div class="row">
            <div class="col-md-1">&nbsp;</div>
            <div class="col-md-5 igs-h3 igs-color2">Importe Pagado</div>
            <div class="col-md-5 igs-h3 igs-color1">{{f91Cantidad(lnImportePago)}} €</div>
            <div class="col-md-1">&nbsp;</div>
          </div> 

    </div>

    <div id="t097m001" style="display:none">
    { 
        "t097m001" : {
            "tkey" : "99000",
            "tmsg" : "{{ltMensajeError}}",
            "t901" : "{{ltReferenciaPedido}}",
            "t902" : "{{ltCodigoError}}",
            "t903" : "{{ltCodigoTienda}}",
            "t904" : "{{ltCodigoTerminal}}",
            "t905" : "{{ltTipoTransaccion}}",
            "t906" : "{{ltCodigoAutorizacion}}",
            "t907" : "{{ltFechaAutorizacion}}",
            "t908" : "{{ltHoraAutorizacion}}",
            "t909" : "{{ltTipoTarjeta}}",
            "t910" : "{{ltPaisTarjeta}}",
            "t911" : "{{ltMonedaOperacion}}",
            "t912" : "{{ltImporteOperacion}}",
            "t913" : "{{ltReferenciaERP}}",
            "t914" : "{{ltPagoSeguro}}",
            "t915" : "{{ltPANTarjeta}}",
            "t916" : "{{ltCaducidadTarjeta}}",
            "t917" : "{{ltIdentificadorTarjeta}}",
            "t918" : "{{ltIdiomaUsuario}}"
        }
    }
    </div>
</div>
</template>

<script>
import igs_mixin from '@/igs-mixins/igs_mixin'

export default {
  mixins: [ igs_mixin ],

  //=======================================================================
  //------------------------ Variables Locales  ---------------------------
  //=======================================================================
  data() {
    return {
        ltMensajeError:         '',
        ltReferenciaPedido:     '',
        ltCodigoError:          '',
        ltTipoTarjeta:          '',
        ltCodigoTienda:         '',
        ltCodigoTerminal:       '',
        ltTipoTransaccion:      '',
        ltCodigoAutorizacion:   '',
        ltFechaAutorizacion:    '',
        ltHoraAutorizacion:     '',
        ltPaisTarjeta:          '',
        ltMonedaOperacion:      '',
        ltImporteOperacion:     '',
        ltReferenciaERP:        '',
        ltPagoSeguro:           '',
        ltPANTarjeta:           '',
        ltCaducidadTarjeta:     '',
        ltIdentificadorTarjeta: '',
        ltIdiomaUsuario:        ''

    }
  },

  //=======================================================================
  //------------------------ Variables Calculadas  ---------------------------
  //=======================================================================
  computed : {

    lnImportePago() {
      return parseInt(this.ltImporteOperacion, 10) / 100;
    }

  },


  //=======================================================================
  //------------------------ Métodos Locales  ---------------------------
  //=======================================================================
  methods: {

      //--------------------------------------------------------
      //-- Mostrar contenido JSON basado en la URL recibida
      //--------------------------------------------------------
      lp20MostrarResultadoJSON() {
        //-- Debug
        //console.log(window.location.href);
        
        //-- Obtener la URL Completa
        var URL = window.location.href;

        //-- Dividir (URL Base) de (Parámetros)
        var URLParams = URL.split("/");
        //console.log('-- URLParams --');
        //console.dir(URLParams);

        //-- Extraer cada uno de los valores
        var TPVParams = URLParams[11].split("%7C");
        //console.log('-- TPVParams --');
        //console.dir(TPVParams);

        //-- Cargar Valores
        this.ltReferenciaPedido     = this.$store.state.strReferenciaPedido;
        this.ltCodigoError          = TPVParams[0];
        this.ltCodigoTienda         = TPVParams[1];
        this.ltCodigoTerminal       = TPVParams[2];
        this.ltTipoTransaccion      = TPVParams[3];
        this.ltCodigoAutorizacion   = TPVParams[4];
        this.ltFechaAutorizacion    = TPVParams[5];
        this.ltHoraAutorizacion     = TPVParams[6];
        this.ltTipoTarjeta          = URLParams[7];
        this.ltPaisTarjeta          = TPVParams[8];
        this.ltMonedaOperacion      = TPVParams[9];
        this.ltImporteOperacion     = TPVParams[10];
        this.ltReferenciaERP        = TPVParams[11];
        this.ltPagoSeguro           = TPVParams[12];
        this.ltPANTarjeta           = TPVParams[13];
        this.ltCaducidadTarjeta     = TPVParams[14];
        this.ltIdentificadorTarjeta = TPVParams[15];
        this.ltIdiomaUsuario        = TPVParams[16];

        //-- Mensaje Informativo para el Usuario
        if (this.ltCodigoError == '0') {
          this.ltMensajeError = 'Operación Aceptada';
        } else {
          this.ltMensajeError = 'Error '+this.ltCodigoError;
        }

      }
      
  },

  //=======================================================================
  //------------ Métodos a aplicar una vez CARGADA la Página  -------------
  //=======================================================================
  mounted() {
    //-- Mensajes
    //console.log('SVC mounted');

    //-- Comprobar la Respuesta Recibida
    this.lp20MostrarResultadoJSON();
  }
}
</script>

<style type="scope">
</style>
